import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const fetchPriceMemoReportData = createApi('api/reports', 'GET');

const PriceMemoReport = createSlice({
  name: 'PriceMemoReport',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPriceMemoReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPriceMemoReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPriceMemoReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PriceMemoReport.reducer;